import React from 'react';
import Image from 'next/image';
import { Stack, Typography, useTheme } from '@mui/material';

import { Container } from '@/components/layout';

function WhyOneVillage() {
  const theme = useTheme();

  return (
    <Stack
      sx={{
        justifyContent: 'flex-end',
        paddingTop: { xs: 0, sm: theme.spacing(11), lg: theme.spacing(14) },
        paddingBottom: { xs: 0, lg: theme.spacing(8) },
      }}
    >
      <Container>
        <Stack
          sx={{
            width: '100%',
            flexDirection: { xs: 'column', lg: 'row' },
            gap: { xs: 0, lg: theme.spacing(15) },
          }}
        >
          <Stack
            sx={{
              gap: theme.spacing(2.5),
              py: { xs: theme.spacing(5), lg: 0 },
              order: { xs: 1, lg: 0 },
              minWidth: 0,
            }}
          >
            <Typography
              variant="h1"
              sx={{
                color: '#52545F',
                fontSize: {
                  xs: '2.375rem !important',
                  lg: '3.125rem !important',
                },
                lineHeight: { xs: '1.2 !important', lg: '1.18 !important' },
              }}
            >
              Why OneVillage?
            </Typography>

            <Typography
              variant="body2"
              color="#34353E"
              sx={{
                fontSize: {
                  xs: '1.125rem !important',
                  lg: '1.25rem !important',
                },
                lineHeight: { xs: '1.46 !important', lg: '1.33 !important' },
              }}
            >
              At OneVillage, we embrace the idea that well-being is not just an
              individual journey—it’s a shared experience. Just like a village
              where people support and uplift each other, our platform connects
              individuals with the personalized guidance, resources, and care
              they need to thrive. We believe health should be simple,
              accessible, and empowering for everyone. By fostering connection
              and support, we’re redefining what it means to take care of
              ourselves and each other—because better health happens together.
            </Typography>
          </Stack>

          <Stack
            sx={{
              minWidth: { xs: '100vw', sm: '100%', lg: '37.8%' },
              marginLeft: { xs: '50%', sm: 'unset' },
              transform: { xs: 'translateX(-50%)', sm: 'unset' },
            }}
          >
            <Stack
              sx={{
                width: '100%',
                aspectRatio: '1.76',
                position: 'relative',
                borderRadius: { xs: 'unset', sm: '16px' },
                overflow: 'hidden',
              }}
            >
              <Image
                src="/images/about-us/why-onevillage.jpg"
                layout="fill"
                objectFit="cover"
                objectPosition="center"
              />
            </Stack>
          </Stack>
        </Stack>
      </Container>
    </Stack>
  );
}

export default WhyOneVillage;
